module.exports = __webpack_public_path__ + "img/white_profileIcon_1.1a783c17.svg";